// Autocomplete cliente - Sprint 32.
import { useEffect, useRef, useState } from 'react';
import { searchClientes } from '../../modules/clientes/services/clientesService';

export default function ClientePicker({ value, cliente, onChange, onPickFull, placeholder = 'Buscar cliente...' }) {
  const [q, setQ] = useState('');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const tRef = useRef(null);

  useEffect(() => {
    if (cliente && cliente.nombre && !q) setQ(cliente.nombre);
    // Sync inicial de cliente.nombre a q. Añadir 'q' como dep causaría que el campo
    // se re-llene al borrarlo, rompiendo la búsqueda nueva.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cliente]);

  useEffect(() => {
    if (!open) return;
    if (tRef.current) clearTimeout(tRef.current);
    tRef.current = setTimeout(async () => {
      setLoading(true);
      try {
        const results = await searchClientes(q, 10);
        setItems(results);
      } finally { setLoading(false); }
    }, 250);
    return () => { if (tRef.current) clearTimeout(tRef.current); };
  }, [q, open]);

  const pick = (c) => {
    onChange(c.id);
    if (onPickFull) onPickFull(c);
    setQ(c.nombre);
    setOpen(false);
  };

  return (
    <div className="relative">
      <input
        type="text"
        value={q}
        onFocus={() => setOpen(true)}
        onChange={(e) => { setQ(e.target.value); setOpen(true); if (!e.target.value) onChange(null); }}
        placeholder={placeholder}
        className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none"
      />
      {open && (
        <div className="absolute z-10 mt-1 w-full bg-white rounded-lg border border-gray-200 shadow-lg max-h-60 overflow-y-auto">
          {loading && <div className="p-3 text-xs text-gray-400">Buscando...</div>}
          {!loading && items.length === 0 && (
            <div className="p-3 text-xs text-gray-400">Sin resultados.</div>
          )}
          {!loading && items.map((c) => (
            <button key={c.id} type="button" onClick={() => pick(c)}
              className="block w-full text-left px-3 py-2 text-sm hover:bg-blue-50">
              <div className="font-medium text-gray-900">{c.nombre}</div>
              <div className="text-[11px] text-gray-500">
                {c.nit ? `NIT ${c.nit}${c.dv ? '-' + c.dv : ''} · ` : ''}
                {c.pais || ''} {c.ciudad ? '· ' + c.ciudad : ''}
              </div>
            </button>
          ))}
          <button type="button" onClick={() => setOpen(false)}
            className="block w-full text-center px-3 py-1.5 text-[11px] text-gray-400 border-t border-gray-100 hover:bg-gray-50">
            Cerrar
          </button>
        </div>
      )}
    </div>
  );
}
